import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const blockages = [{
  name: 'Miedo al Éxito',
  desc: 'Justo cuando las cosas van bien, algo se arruina'
}, {
  name: 'Síndrome del Impostor',
  desc: 'Dudas de tu valor y crees que tus logros son "suerte"'
}, {
  name: 'Sabotaje Inconsciente',
  desc: 'Das descuentos que nadie pidió. Evitas revisar tus cuentas'
}, {
  name: 'Creencias Heredadas',
  desc: 'Creciste escuchando "el dinero es malo" o "para ganar hay que sufrir"'
}, {
  name: 'Identidad de Escasez',
  desc: 'Te defines como "nunca me alcanza" o "no soy bueno con el dinero"'
}];
export function ProblemSection() {
  return <section className="py-12 md:py-16 px-4 md:px-8 bg-navy-midnight" data-id="element-236">
      <div className="max-w-4xl mx-auto" data-id="element-237">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16" data-id="element-238">
          <h3 className="text-3xl md:text-5xl font-headline font-extrabold text-white mb-8 text-center max-w-3xl mx-auto leading-tight" data-id="element-239">
            Hay algo que nadie te
            <br data-id="element-240" />
            dijo
          </h3>

          <div className="space-y-6 text-lg text-body font-body" data-id="element-241">
            <p data-id="element-242">
              Trabajas duro. Te esfuerzas. Quizás incluso has tomado cursos,
              leído libros, visto videos de finanzas.
            </p>
            <p className="text-gold-light font-headline font-semibold text-xl" data-id="element-243">
              Y sin embargo... el dinero sigue siendo esquivo.
            </p>
            <p data-id="element-244">
              Algunos meses mejora. Pero luego algo pasa. Un gasto inesperado.
              Un cliente que no paga. Una decisión que, mirando atrás, no tiene
              sentido lógico.
            </p>
            <p data-id="element-245">¿Mala suerte? No.</p>
            <p className="text-gold font-headline font-bold text-xl" data-id="element-246">
              Es un programa. Y corre en tu mente las 24 horas del día.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="mb-16" data-id="element-247">
          <h4 className="text-2xl font-headline font-bold text-white mb-8 text-center" data-id="element-248">
            ¿Te identificas con alguno de estos patrones?
          </h4>

          <div className="flex flex-col gap-4" data-id="element-249">
            {blockages.map((block, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-navy-dark border-l-4 border-gold p-6 rounded-r-xl flex flex-col md:flex-row md:items-center gap-4 hover:bg-navy-dark/80 transition-colors shadow-soft" data-id="element-250">
                <div className="md:w-1/3 font-headline font-bold text-gold-light text-lg flex items-center gap-2" data-id="element-251">
                  <span className="text-gold" data-id="element-252">🔸</span> {block.name}
                </div>
                <div className="md:w-2/3 text-body font-serif italic" data-id="element-253">
                  "{block.desc}"
                </div>
              </motion.div>)}
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-navy-dark border border-gold/30 rounded-2xl p-8 md:p-12 mb-16 shadow-gold relative overflow-hidden" data-id="element-254">
          <div className="absolute top-0 right-0 w-64 h-64 bg-gold/5 rounded-full blur-[80px]" data-id="element-255"></div>

          <h4 className="text-xl md:text-2xl font-headline font-bold text-gold mb-8 text-center" data-id="element-256">
            📊 La Estadística Que Lo Cambia Todo:
          </h4>

          <div className="space-y-6 text-center relative z-10" data-id="element-257">
            <p className="text-2xl md:text-3xl font-serif text-white" data-id="element-258">
              El{' '}
              <span className="text-gold font-headline font-extrabold text-4xl" data-id="element-259">
                95%
              </span>{' '}
              de tus decisiones financieras las toma tu subconsciente.
            </p>
            <p className="text-2xl md:text-3xl font-serif text-white" data-id="element-260">
              El{' '}
              <span className="text-gold font-headline font-extrabold text-4xl" data-id="element-261">
                80%
              </span>{' '}
              de tus creencias sobre el dinero fueron instaladas antes de los 7
              años.
            </p>
            <div className="pt-6 border-t border-gold-separator/30" data-id="element-262">
              <p className="text-lg text-gold-light italic font-serif" data-id="element-263">
                Esto significa que no es falta de información. Es falta de
                reprogramación.
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-264">
          <h3 className="text-3xl font-headline font-extrabold text-white mb-6" data-id="element-265">
            Tu miedo no es gratis.
          </h3>
          <p className="text-lg text-body font-body mb-8 max-w-2xl mx-auto" data-id="element-266">
            Cada mes que este programa sigue activo en tu mente, te cuesta entre{' '}
            <strong className="text-gold font-headline font-bold text-xl" data-id="element-267">
              $1,000 y $5,000 USD
            </strong>{' '}
            en ventas perdidas, oportunidades que no ves y decisiones que
            sabotean tu crecimiento.
          </p>
          <p className="text-xl text-white font-headline font-bold mb-10" data-id="element-268">
            ¿Cuántos meses más vas a permitir que eso continúe?
          </p>

          <div className="flex flex-col items-center gap-3 mb-6" data-id="element-269">
            <span className="inline-block bg-gold-badge text-gold-light text-sm font-headline font-bold px-4 py-1.5 rounded-full border border-gold/30 tracking-wide" data-id="element-270">
              🔥 83% DE DESCUENTO
            </span>
            <div className="flex items-center justify-center gap-4" data-id="element-271">
              <span className="text-2xl text-body line-through font-bold opacity-80" data-id="element-272">
                $37 USD
              </span>
              <span className="text-3xl text-gold font-headline font-extrabold" data-id="element-273">
                → $6.36 USD
              </span>
            </div>
          </div>

          <CTAButton href="https://vitalyforms.com/cart/48329378398428:1" className="w-full md:w-auto" data-id="element-274">
            QUIERO DETENER EL SANGRADO FINANCIERO AHORA
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}